import { useFormContext } from '@hooks/react-hook-form';

import ApplicationCard from '../../../../../application-card';
import ApplicationAlert from '../../../../../application-alert';
import SectionTitle from '../../../../../section-title';

import ApplicationCamera from '../../application-camera';

import { IdentityPhotoProps } from './types';

const IdendityPhoto = (props: IdentityPhotoProps) => {
  const { readonly } = props;
  const {
    formState: { isSubmitting, isSubmitSuccessful },
  } = useFormContext();

  return (
    <ApplicationCard className='section-identity-photo'>
      <SectionTitle title='Identitas Diri' />
      {!readonly && (
        <ApplicationAlert
          marginBottom='1.25rem'
          message='Kami membutuhkan foto KTP dan selfie kamu untuk proses verifikasi. Mohon
        siapkan KTP dan pastikan tidak ada orang lain di sekitar kamu.'
        />
      )}
      <ApplicationCamera
        readonly={readonly}
        name='ktp'
        label='Foto KTP'
        cameraFacing='back'
        isLoading={isSubmitting && !isSubmitSuccessful}
      />
      <ApplicationCamera
        readonly={readonly}
        name='selfieKtp'
        label='Foto Selfie'
        isLoading={isSubmitting && !isSubmitSuccessful}
      />
    </ApplicationCard>
  );
};

export default IdendityPhoto;
